import type {
  LightingAdvisorResults,
  LightingAdvisorTileId
} from '~/types/lightingAdvisor';
import {
  LIGHTING_ADVISOR_MAGENTO_FILTER_KEYS_BY_TILE,
  LIGHTING_ADVISOR_WORKING_DISTANCE_RANGE_MAX
} from '~/utils/lightingAdvisor/constants';

export function mapLightingResultsToMagentoFilters(
  results: LightingAdvisorResults
): Record<string, string[]> {
  const filters: Record<string, string[]> = {};

  if (results.light_category?.length) {
    filters.light_category_parent = [...results.light_category];
  }

  if (results.light_type?.length) {
    filters.light_category = [...results.light_type];
  }

  if (results.light_color?.length) {
    filters.light_color = [...results.light_color];
  }

  if (results.peak_wavelength_typical) {
    filters.peak_wavelength_typical = [results.peak_wavelength_typical];
  }

  const length = results.max_object_size?.length;
  const width = results.max_object_size?.width;
  if (length != null && width != null) {
    filters.maximum_object_size_length_x_width = [`${length}x${width}`];
  }

  if (results.working_distance != null) {
    filters.recommended_max_wd = [
      String(results.working_distance),
      LIGHTING_ADVISOR_WORKING_DISTANCE_RANGE_MAX
    ];
  }

  return filters;
}

export function mapLightingResultsToMagentoFiltersForTile(
  results: LightingAdvisorResults,
  tileId: LightingAdvisorTileId
): Record<string, string[]> {
  const all = mapLightingResultsToMagentoFilters(results);
  const allowedKeys = LIGHTING_ADVISOR_MAGENTO_FILTER_KEYS_BY_TILE[tileId];
  const filters: Record<string, string[]> = {};
  for (const key of allowedKeys) {
    const values = all[key];
    if (values?.length) {
      filters[key] = values;
    }
  }
  return filters;
}
